import { Icon, IconProps } from '@chakra-ui/react'

export default function TherapistIcon(props: IconProps) {
  const strokeWidth = props.strokeWidth ?? '0.75'

  return (
    <Icon
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#077FDE'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99956 0.998047H7.0004C7.55291 0.998047 8.00081 1.44595 8.00081 1.99846V3.9993C8.00081 5.10433 7.10501 6.00013 5.99998 6.00013V6.00013C4.89495 6.00013 3.99915 5.10433 3.99915 3.9993V1.99846C3.99915 1.44595 4.44705 0.998047 4.99956 0.998047Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.05097 5.70312L7.42263 7.18974"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.95009 5.70312L4.57844 7.18974"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.99913 7.07812V9.00064"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="3.99915"
        cy="9.75227"
        r="0.750313"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00084 7.07812V9.00064"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.13925 10.5026C7.04961 10.351 7.00171 10.1784 7.00043 10.0024V10.0024C7.00043 9.44985 7.44833 9.00195 8.00084 9.00195V9.00195C8.55336 9.00195 9.00126 9.44985 9.00126 10.0024V10.0024C8.99998 10.1784 8.95208 10.351 8.86244 10.5026"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00081 3.0001H3.99915"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.49811 9.50225V8.80986C1.49811 8.0945 2.00305 7.47859 2.70454 7.33834L4.1282 7.05373C4.24583 7.03019 4.36798 7.05429 4.46784 7.12075V7.12075C5.39556 7.73954 6.60441 7.73954 7.53212 7.12075V7.12075C7.63198 7.05429 7.75414 7.03019 7.87176 7.05373L9.29543 7.33834C9.99691 7.47859 10.5019 8.0945 10.5019 8.80986V9.50225"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
